import React from 'react';
import styled from 'styled-components/macro';
import GreenArrowIcon from '../../images/ic-arrow-asc-red-30px-17px.png';
import RedArrowIcon from '../../images/ic-arrow-desc-green-30px-19px.png';
// Available props for this component

// CSS props:
// width, height, backgroundColor, border, borderRadius, padding, boxShadow,fontSize, subValueFontSize hoverEffect(boolean)

// Other props:
// values(required) = {value:'string', subValue:'string', caption:'string', subCaption:'string'}
// arrow = 'asc' or 'desc'

const StatViewWrapper = styled.div`
    font-family: ${props => props.fontFamily ? props.fontFamily : "inherit"};
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: normal;
    width: ${props => props.width ? props.width : '200px'};
    height: ${props => props.height ? props.height : '120px'};
    color: ${props => props.valueColor ? props.valueColor : 'black'};
    background-color: ${props => props.backgroundColor ? props.backgroundColor : 'rgb(255, 255, 255)'};
    border: ${props => props.border ? props.border : '1px solid rgb(255, 255, 255)'};
    border-radius: ${props => props.borderRadius ? props.borderRadius : '5px'};
    padding: ${props => props.padding ? props.padding : '1rem'};
    box-shadow: ${props => props.boxShadow ? props.boxShadow : 'rgb(0 0 0 / 18%) 2px 2px 15px'};
    &:hover {
        box-shadow: ${props => props.hoverEffect ? '2px 2px 15px 0 rgb(0 0 0 / 48%)' : null};
    }
`;
const StatViewValueContainer = styled.div`
    display: flex;  
    justify-content: space-around;
    align-items: center;
`;

 const StatViewValue = styled.div`
    font-size: ${props => props.fontSize ? props.fontSize : '32px'};
    line-height: 37px;
    text-align: center;
    color: ${props => props.valueColor ? props.valueColor : 'rgba(74, 74, 74, 1)'};
 `;

 const StatViewSubValue = styled.span`
    font-size: ${props => props.subValueFontSize ? props.subValueFontSize : '22px'};
    color: ${props => props.subValueColor ? props.subValueColor : 'rgba(74, 74, 74, 1)'};
 `;

 const StatViewCaption = styled.span`
    font-size: ${props => props.captionFontSize ? props.captionFontSize : '12px'};
    line-height: ${props => props.captionLineHeight ? props.captionLineHeight : '14px'};
    color: ${props => props.captionColor ? props.captionColor : 'rgba(116, 120, 125, 1)'};
    text-align: center;
 `;

 const StatViewSubCaption = styled.span`
    font-size: ${props => props.subCaptionFontSize ? props.subCaptionFontSize : '10px'};
    line-height: ${props => props.subCaptionLineHeight ? props.subCaptionLineHeight : '14px'};
    color: ${props => props.subCaptionColor ? props.subCaptionColor : 'rgba(116, 120, 125, 1)'};
    text-align: center;
 `;


const Arrows = styled.img`
    width: 15px;
    padding-right: 3px;
`;


function StatView (props) {
    const values = props.values;
    if (!values || typeof values.value === 'undefined') {
        return (
            <StatViewWrapper id={props.id ? props.id : null} {...props}>
                No Data
            </StatViewWrapper>
            )
        }

    return (
        <StatViewWrapper {...props}>
            <StatViewValueContainer>
                {props.arrow ? <Arrows src={props.arrow === 'asc' ? GreenArrowIcon : props.arrow === 'desc' ? RedArrowIcon : null}/> : null}
                <StatViewValue id={props.valueId} {...props}>{values.value ? values.value : null}
                </StatViewValue>
                <StatViewSubValue id={props.subValueId} {...props}>{values.subValue ? values.subValue : null}</StatViewSubValue>
            </StatViewValueContainer>
            <StatViewCaption id={props.captionId} {...props}>{values.caption ? values.caption : null}</StatViewCaption>
            <StatViewSubCaption id={props.subCaptionId} {...props}>{values.subCaption ? values.subCaption : null}</StatViewSubCaption>
        </StatViewWrapper>
    )
}
export default StatView;
